/**
 * Reusable selection card for the wizard (mode, theme, frame, filter tiles).
 * Handles selected/hover/disabled states with a consistent visual language.
 */

import React from 'react'
import { FaCheck } from 'react-icons/fa'

interface SelectableCardProps {
  selected: boolean
  onClick: () => void
  children: React.ReactNode
  className?: string
  /** Show a check badge in the corner when selected. */
  showCheck?: boolean
  ariaLabel?: string
}

export const SelectableCard: React.FC<SelectableCardProps> = ({
  selected,
  onClick,
  children,
  className = '',
  showCheck = true,
  ariaLabel
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={selected}
      aria-label={ariaLabel}
      className={`group relative overflow-hidden rounded-2xl text-left transition-all duration-150 focus:outline-none ${
        selected
          ? 'ring-2 ring-blueSparkle ring-offset-2 ring-offset-transparent'
          : 'ring-1 ring-white/10 hover:ring-white/30'
      } ${className}`}
    >
      {children}
      {showCheck && selected && (
        <span className="absolute right-2 top-2 flex h-6 w-6 items-center justify-center rounded-full bg-blueSparkle text-white shadow">
          <FaCheck className="text-[11px]" />
        </span>
      )}
    </button>
  )
}

export default SelectableCard
